module.exports = __webpack_public_path__ + "static/img/footer-wechat-text.2a62e578.png";